import {
  Alert,
  AlertDescription,
} from "@arcadeai/design-system/components/ui/atoms/alert";
import { TrendingDown } from "lucide-react";
import { useScheduledChangeHelpers } from "@/app/billing/api/use-scheduled-change-helpers";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";

export const ScheduledChangeAlert = () => {
  const { organizationId } = useOrgProjectRouteContext();
  const { hasScheduledChange, nextScheduledChange, formatDate } =
    useScheduledChangeHelpers(organizationId);

  if (!(hasScheduledChange && nextScheduledChange)) {
    return null;
  }

  return (
    <Alert
      className="border-amber-200 bg-amber-50 shadow-sm dark:border-amber-800 dark:bg-amber-950/30"
      variant="default"
    >
      <TrendingDown className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      <AlertDescription className="text-amber-900 leading-relaxed dark:text-amber-100">
        <p>
          Your plan will change to{" "}
          <span className="font-semibold text-amber-800 dark:text-amber-200">
            {nextScheduledChange.plan.name}
          </span>{" "}
          on{" "}
          <span className="font-semibold text-amber-800 dark:text-amber-200">
            {formatDate(nextScheduledChange.start_date)}.
          </span>
          <br />
          <ul className="mt-2 list-inside list-disc">
            <li>
              This change will take effect at the start of your next billing
              cycle.
            </li>
          </ul>
        </p>
      </AlertDescription>
    </Alert>
  );
};
